module.exports = __webpack_public_path__ + "r-v3/img/gt-Volume_on.41eeecca.svg";